import React from 'react';
import PropTypes from 'prop-types';

import {
    Button,
    Text,
    TextButton,
} from '@zillow/constellation';

// style
import './style.scss';

const propTypes = {
    textContent: PropTypes.node.isRequired,
    submitButtonTitle: PropTypes.string,
    cancelButtonTitle: PropTypes.string,
    onSubmit: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
};

const defaultProps = {
    submitButtonTitle: 'Confirm',
    cancelButtonTitle: 'Cancel',
};

const ConfirmationModal = ({
    submitButtonTitle,
    cancelButtonTitle,
    textContent,
    onSubmit,
    onCancel,
}) => (
    <div className="ConfirmationModal">
        {textContent && (
            <Text>
                {textContent}
            </Text>
        )}
        <div className="ConfirmationModal-controls">
            <TextButton onClick={onCancel} className="ConfirmationModal-cancel">
                {cancelButtonTitle}
            </TextButton>
            <Button
                onClick={onSubmit}
                buttonType="primary"
            >
                {submitButtonTitle}
            </Button>
        </div>
    </div>
);

ConfirmationModal.propTypes = propTypes;
ConfirmationModal.defaultProps = defaultProps;

export { ConfirmationModal };
export default ConfirmationModal;
